bcn.relation_picker = (function () {
  'use strict';

  function toggleOther(select) {
    var is_other = select.val()  === 'Other';
    $('.js-relation-input').
      toggle(is_other).
      prop('disabled', !is_other).
      parent().toggle(is_other);
  }

  function setFocus() {
    var $otherInput = $('input#tribute_fund_relation');
    if (!$otherInput.prop('disabled')) {
      $otherInput.focus();
    }
  }

  return {
    init: function () {
      var $relation_select = $('.js-relation-select');
      var $relation_input = $('.js-relation-input');

      // Has the user filled in an other option
      if ($relation_select.val() === '' && $relation_input.val() !== '') {
        $relation_select.val('Other');
      }

      toggleOther($relation_select);
      $('body').on('change', '.js-relation-select', function () {
        $relation_input.val('');
        toggleOther($(this));
        setFocus();
      });
    }
  };
})();
